import { Avatar, Heading } from '@lmc/ui-kit'
import { styled } from 'styled-components'
import InfoIcons from 'screens/Rostering/RotaBuilder/common/components/InfoIcons'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Home } from '@lmc/ts-common'
import { getNominative } from '@lmc/common/utils'

const DeletedServiceUser = () => {
  const { t } = useTranslation()

  const preferredPeopleNominative = useSelector(
    (state: { global: { home: Home } }) =>
      state.global.home.preferredPeopleNominative
  )

  const residentNominative = getNominative(
    preferredPeopleNominative,
    'Resident'
  )

  return (
    <SectionWrapper>
      <StyledAvatar size={40} />
      <Heading level={5} weight="medium">
        {t('DELETED_NOMINATIVE', { nominative: residentNominative })}
      </Heading>
      <InfoIcons deleted residentStatus={t('DELETED')} />
    </SectionWrapper>
  )
}

const StyledAvatar = styled(Avatar)`
  border: 0.5px solid ${(props) => props.theme.color.neutral.color7};
`

const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export default DeletedServiceUser
